import { Component, Prop, h, State, Event, EventEmitter } from '@stencil/core';
import { ButtonState } from './types';

@Component({
  tag: 'vsr-carousel-button-v2',
  styleUrl: 'vsr-button.scss',
  shadow: true,
})
export class VsrCarouselButton {
  @Prop() orientation: 'left' | 'right' = 'left';
  @Prop() state: ButtonState = 'active';
  @Prop() focused: boolean = false;

  @State() isFocused: boolean = false;

  @Event() vsrClick: EventEmitter<MouseEvent>;

  componentWillLoad() {
    this.isFocused = this.focused;
  }

  private handleClick = (event: MouseEvent) => {
    this.vsrClick.emit(event);
  };

  render() {
    const buttonClass = `carousel-button ${this.orientation} ${this.state.toLowerCase()} ${this.isFocused ? 'focused' : ''}`;

    return (
      <button
        class={buttonClass}
        onClick={this.handleClick}
        onFocus={() => (this.isFocused = true)}
        onBlur={() => (this.isFocused = false)}
        aria-label={`${this.orientation} carousel navigation`}
      >
        {this.orientation === 'left' ? '←' : '→'}
        {this.isFocused && <div class="focus-ring"></div>}
      </button>
    );
  }
}
